export const IRAN_WAR_START = "2026-02-28";

export const IRAN_WAR_CHECK = {
  date: "2026-09-13",
  title: "Iran’s nuclear chief not expected to attend IAEA General Conference, official says",
  url: "https://apnews.com/article/iran-nuclear-iaea-conference-eslami-travel-ban-ce4bab96e46c11269b8daff2e339f0c8",
};

export const IRAN_WAR_STATUS_CHANGES = [
  {
    date: "2026-02-28",
    status: "war",
    summary: "The U.S. attacks Iran, and Iran responds with strikes across the Gulf.",
    source: "ABC News",
    sourceTitle: "Four phases of the Iran war",
    sourceUrl:
      "https://abcnews.com/International/4-phases-iran-war-key-moments-start-epic/story?id=132703824",
  },
  {
    date: "2026-04-07",
    status: "peace",
    summary: "A U.S.-Iran ceasefire pauses direct exchanges of fire.",
    source: "AP News",
    sourceTitle: "U.S. and Iran agree to a two-week ceasefire",
    sourceUrl:
      "https://apnews.com/article/iran-us-israel-trump-lebanon-april-7-2026-421ee64fdc9a5c26460df8119c7d1b3f",
  },
  {
    date: "2026-05-04",
    status: "war",
    summary: "Iran attacks commercial and U.S. vessels; U.S. forces destroy Iranian boats.",
    source: "Stars and Stripes",
    sourceTitle: "U.S. forces intercept Iranian attacks in the Strait of Hormuz",
    sourceUrl:
      "https://www.stripes.com/theaters/middle_east/2026-05-04/us-intercepts-iranian-missiles-strait-of-hormuz-21573524.html",
  },
  {
    date: "2026-05-08",
    status: "peace",
    summary: "Iran says the situation returned to normal, and the U.S. says it does not want to escalate.",
    source: "Reuters via ThePrint",
    sourceTitle: "U.S. and Iran exchange fire, then return to the ceasefire",
    sourceUrl:
      "https://theprint.in/world/us-and-iran-exchange-fire-but-trump-says-ceasefire-still-in-effect/2925386/",
  },
  {
    date: "2026-05-27",
    status: "war",
    summary: "Iran launches attack drones and a ballistic missile toward Kuwait.",
    source: "U.S. Central Command",
    sourceTitle: "CENTCOM statement on renewed Iranian attacks",
    sourceUrl:
      "https://www.centcom.mil/MEDIA/PUBLIC-RELEASES/Article/4502431/statement-from-centcom-on-recent-iranian-aggression/",
  },
  {
    date: "2026-06-12",
    status: "peace",
    summary: "A three-day exchange of fire stops as mediators announce agreement on a peace deal's wording.",
    source: "AP News",
    sourceTitle: "U.S. and Iran agree to wording of a deal to end the war",
    sourceUrl: "https://apnews.com/article/7085e386e1c40ee6cfe634210970143f",
  },
  {
    date: "2026-07-07",
    status: "war",
    summary: "The U.S. strikes targets in Iran after Iranian attacks on ships in Hormuz.",
    source: "AP News",
    sourceTitle: "U.S. and Iran resume trading strikes",
    sourceUrl:
      "https://apnews.com/article/iran-us-timeline-trump-hormuz-war-ceasefire-04da58cbae991183f8b52ef5bf615963",
  },
  {
    date: "2026-07-26",
    status: "peace",
    summary: "The U.S. and Iran pause attacks for a second straight day.",
    source: "AP News",
    sourceTitle: "US pauses attacks on Iran for a second straight day and Tehran does too",
    sourceUrl:
      "https://apnews.com/article/iran-war-united-states-ceasefire-ad9fa27d5b1b5fd51e30d923ee738238",
  },
  {
    date: "2026-07-28",
    status: "war",
    summary: "Iran launches ballistic missiles at U.S. forces, ending the brief pause in fighting.",
    source: "AP News",
    sourceTitle:
      "US thwarts an Iranian missile attack and launches strikes with Saudi Arabia against militias in Iraq",
    sourceUrl:
      "https://apnews.com/article/iran-war-us-trump-saudi-houthis-iraq-8d2ae29300a8dc5495a4ce56c5312bf1",
  },
  {
    date: "2026-08-22",
    status: "peace",
    summary: "The U.S. and Iran stop exchanging fire, though peace talks remain stalled.",
    source: "Reuters via ThePrint",
    sourceTitle: "US, Iran keep up hostile rhetoric ahead of new sanctions",
    sourceUrl:
      "https://theprint.in/world/us-iran-keep-up-hostile-rhetoric-ahead-of-new-sanctions/3021929/",
  },
  {
    date: "2026-08-30",
    status: "war",
    summary: "U.S. forces strike Iranian rocket launchers, and Iran launches missiles at U.S. sites in Jordan.",
    source: "AP News",
    sourceTitle:
      "US strikes Iranian rocket launchers on the Strait of Hormuz in first military action in weeks",
    sourceUrl:
      "https://apnews.com/article/iran-strait-hormuz-strike-united-states-6b098da673ac3161a266ee459d5eff44",
  },
];

export const IRAN_WAR_DAILY_HEADLINES = [
  "Live Israel launches attacks on Iran multiple explosions heard in Tehran",
  "How US Israel attacks on Iran threaten the strait of Hormuz oil markets",
  "Not again gaza rushes to stockpile amid Iran war crossing closures",
  "How much could the Iran war cost the US heres what we know",
  "South koreas stock market in meltdown amid US Iran war",
  "Iran war what is happening on day six of US Israel attacks",
  "Iran war what is happening on day seven of US Israel attacks",
  "Iran war live Trump says no deal with Iran until unconditional surrender",
  "Iran war what is happening on day nine of US Israel attacks",
  "Iran war live mojtaba Khamenei named supreme leader Israel bombs Tehran",
  "Iran war live Trump says conflict will be over soon 40 killed in Tehran",
  "Iran war live Tehran says US Israel hit nearly 10000 civilian sites",
  "Iran war live oil tankers hit in iraq Tehran sets 3 conditions for peace",
  "Iran war live Trump says war going well as gulf under wave of attacks",
  "Iran war live pentagon vows to ramp up US military campaign against Iran",
  "Iran war live Trump urges world to keep Hormuz strait open",
  "Iran war live Tehran rejects Trump claim on talks gulf attacks continue",
  "Iran war live Trump scolds allies for not joining strait of Hormuz mission",
  "Iran war live Tehran mourns larijani soleimani two killed in Israel",
  "Iran war live Qatar saudi energy sites attacked riyadh says trust gone",
  "Iran war live Tehran warns of intensified strikes if energy sites targeted",
  "Iran war live Trump says other nations have to protect Hormuz from Iran",
  "Iran war live Trump threatens attacks on power plants over Hormuz strait",
  "Iran war live Tehran vows to completely close Hormuz if power plants hit",
  "Iran war live Tehran says trumps claims of peace talks fake",
  "Iran war live Trump again says talks underway 12 killed in south Tehran",
  "Iran war live US demands Tehran accept defeat Israel pounds Lebanon",
  "Iran war live Trump delays attacks on Iranian energy sector by 10 days",
  "Iran war live Trump again slams natos lack of support for war on Tehran",
  "Iran war live houthis attack Israel anti war protesters rally in tel aviv",
  "Iran war live worker killed in Kuwait Israel intercepts drones from yemen",
  "Iran war live kuwaiti oil tanker hit in dubai port 3 UN troops killed",
  "Iran war what is happening on day 33 of US Israel attacks",
  "Iran war live Trump to address nation Tehran denies seeking ceasefire",
  "Iran war live Trump warns assault on infrastructure hasnt even started",
  "Iran war live Tehran downs 2 US warplanes Israel bombs Lebanon bridges",
  "Iran war live Tehran rejects trumps ultimatum fire at Kuwait oil complex",
  "Iran war live Tehran rejects trumps tuesday deadline on strait of Hormuz",
  "Iran war live Trump warns of devastating attacks as deal deadline nears",
  "Iran war live Trump announces truce Tehran agrees safe transit in Hormuz",
  "Iran war live Israel kills 254 in Lebanon shaking Trump Tehran ceasefire",
  "Iran war live Israeli attacks on Lebanon threaten US Iran ceasefire talks",
  "Iran war live US negotiators due to arrive in pakistan for ceasefire talks",
  "Iran war live historic face to face talks with US continue in islamabad",
  "Iran war live US military to block Iranian port traffic in Hormuz strait",
  "Iran war live Trump claims Tehran wants a deal amid US blockade of Hormuz",
  "Iran war live Trump hints at second round of talks Israel pounds Lebanon",
  "Iran war live pakistan in push for new round of US Iran peace negotiations",
  "Iran war live ceasefire starts in Lebanon as Trump says Tehran deal close",
  "Iran war live Tehran says president Trump made false claims amid talks",
  "Iran war live Tehran says no date set for US talks Hormuz strait closed",
  "Iran war live Tehran slams uss piracy after ship seizure vows response",
  "Iran war live Tehran shuns talks Trump says US blockade to remain",
  "Iran war live Trump says ceasefire extended as talks with Tehran in limbo",
  "Iran war live Israel kills lebanese journalist Tehran US talks stalled",
  "Iran war live Lebanon truce extended Trump says time not on tehrans side",
  "Iran war live tehrans fm in islamabad US says envoys to travel for talks",
  "Iran war live Tehran rejects talks under siege Trump cancels envoys trip",
  "Iran war live araghchi to meet putin Trump says Tehran can call for talks",
  "Iran war live Trump reviews peace plan UN calls for Hormuz to reopen",
  "Iran war live Trump says Tehran wants end to blockade Israel kills medics",
  "Iran war live Trump urges Tehran to just give up as oil prices surge",
  "Iran war live Tehran says US ports siege intolerable Trump mulls action",
  "Iran war live Trump says no early end to war unhappy with Tehran offer",
  "Iran war live Trump says reviewing 14 point plan Israel pounds Lebanon",
  "Iran war live Tehran says trumps Hormuz mission violates ceasefire",
  "Iran war live washington Tehran trade threats over strait of Hormuz",
  "Iran war live Trump says Hormuz operation paused amid US Tehran talks",
  "Iran war day 69 Tehran reviewing US proposals Israel bombs beirut",
  "Iran war day 70 US Iran trade fire in Hormuz amid ceasefire tensions",
  "Iran war live tehrans reply to US deal expected amid clashes in Hormuz",
  "Iran war day 72 Tehran yet to reply to US plan Israel bombs Lebanon",
  "Iran war day 73 Trump and Tehran clash over latest peace proposals",
  "Iran war live Trump slams Iranian proposal as ceasefire hangs by a thread",
  "Iran war live Trump travels to china as conflict with Tehran looms large",
  "Iran war live Tehran slams collusion as netanyahu secretly visits UAE",
  "Iran war day 77 Trump xi discuss Hormuz as Tehran rallies brics",
  "Iran war day 78 Trump Tehran signal talks as Lebanon truce extended",
  "Iran war day 79 Tehran to unveil Hormuz toll plan Israel bombs Lebanon",
  "Iran war day 80 Trump issues warning Tehran ready to confront aggression",
  "Iran war day 81 Trump delays attack Tehran says wont surrender",
  "Iran war day 82 Tehran warns of new fronts as Trump sets deadline",
  "Iran war day 83 Tehran reviewing latest US response to end conflict",
  "Iran war day 84 US Iran talks advance amid mediation push",
  "Iran war day 85 Tehran says major gaps remain in US talks",
  "Iran war day 86 Trump announces potential deal amid cloud of mistrust",
  "Iran war day 87 Trump says US not in rush to sign deal dashing optimism",
  "Iran war day 88 US attacks near strait of Hormuz talks under way in Qatar",
  "Iran war day 89 Lebanon strikes kill 31 as ceasefire tensions rise",
  "Iran war live Israel orders mass forced displacement for all south Lebanon",
  "Iran war live Tehran Trump yet to comment on 60 day truce extension plan",
  "Iran war live Trump due to make final determination on deal with Tehran",
  "Iran war day 93 Trump wont rush deal Israel expands Lebanon invasion",
  "Iran war day 94 US strikes Iranian sites Kuwait intercepts missiles",
  "Iran war day 95 Trump pushes Lebanon truce after Tehran vows to end talks",
  "Iran war live US strikes irans qeshm says Tehran attacks Kuwait bahrain",
  "Iran war day 97 Tehran says no progress in talks Israel attacks Lebanon",
  "Iran war day 98 Tehran raises doubts on deal as Lebanon fighting continues",
  "Iran war live US says Iranian drones shot down radar sites attacked",
  "Iran war day 100 US Iran trade attacks again raising tensions",
  "Iran war day 101 tensions escalate as Iran and Israel trade air attacks",
  "Iran war day 102 Trump warns Israel against new strikes as ceasefire holds",
  "Iran war day 103 US strikes after helicopter shot down Tehran hits back",
  "Iran war day 104 Iran says it attacks US bases after american strikes",
  "Iran war live Trump claims Tehran deal approved cancels new strikes",
  "Iran war live US Tehran signal peace deal within reach but not signed yet",
  "Iran war day 107 washington Tehran close to signing first stage of deal",
  "Iran war live Tehran says peace deal ends US blockade war on all fronts",
  "Iran war day 109 Tehran washington sign mou electronically",
  "Iran war day 110 Tehran says Israeli attacks on Lebanon threaten US deal",
  "Iran war day 111 Tehran warns US as 14 point plan takes effect",
  "Iran war day 112 vance defends Tehran deal but switzerland trips are off",
  "Iran war day 113 Tehran presses US over Lebanon ceasefire",
  "Iran war day 114 US Iranian delegations in switzerland for key talks",
  "Iran war live first day of US talks covers Lebanon Hormuz frozen assets",
  "Iran war day 116 US eases Iran sanctions Lebanon ceasefire holds",
  "Iran war live Trump Tehran at odds over nuclear inspections Hormuz",
  "Iran war day 118 IRGC rejects new Hormuz route rubio to meet GCC leaders",
  "Iran war live Israel attacks Lebanon as netanyahu says troops to stay",
  "Iran war day 120 Tehran condemns US strikes says its violation of mou",
  "Iran war day 121 Iran attacks bahrain Kuwait as US strikes near Hormuz",
  "Iran war live Tehran insists on control of Hormuz amid reports of US talks",
  "Iran war live Tehran denies trumps claims of meeting in doha",
  "Iran war live qatars pm meets US envoys Tehran holds firm on conditions",
  "Iran war live positive progress as US Tehran wrap up indirect talks",
  "Iran war live Tehran slams US ahead of huge funeral for ali Khamenei",
  "Iran war live millions expected in Tehran for funeral of ali Khamenei",
  "Iran war live huge crowds mourn Khamenei Trump vows calm during funeral",
  "Iran war live Tehran set for khameneis procession Israel bombs Lebanon",
  "Iran war live khameneis body arrives in qom hamas cedes gaza governance",
  "Iran war live US bombs sirik qeshm bandar abbas over Hormuz attacks",
  "Iran war live one killed as US bombs bushehr chabahar bandar abbas jask",
  "Iran war live fresh attacks on Iran as US says talks still on",
  "Iran war live US demands Iran publicly state strait of Hormuz open for all",
  "Iran war live IRGC declares strait of Hormuz closed over US interference",
  "Iran war live US bombs Iranian cities again as Hormuz standoff intensifies",
  "Iran war live US launches more attacks Trump orders blockade in Hormuz",
  "US reimposes blockade and resumes daylight strikes as Iran attacks Gulf states",
  "US begins a sixth night of strikes hitting Qeshm Island and areas near Bandar Abbas",
  "US hits Iranian bridges and Chabahar port as Iran strikes Kuwaiti water plant",
  "US and Iran exchange infrastructure strikes as Tehran suspends interim deal commitments",
  "US launches retaliatory strikes on Iran as Tehran fires missiles toward Jordan",
  "US expands strikes on Iran as Tehran attacks Bahrain and Kuwait",
  "US strikes Iran for a 10th straight night as Iran attacks a tanker in Hormuz",
  "Iran targets Aqaba with missiles and drones as US strikes Iranian aircraft hangars and drone sites",
  "A Houthi attack sets a Saudi oil tanker ablaze after rebels threaten a Red Sea blockade",
  "US strikes Iran from the south to the Caspian coast as Tehran targets American bases across the region",
  "Houthis fire on Saudi Red Sea oil sites as Saudi-backed forces bomb Houthi targets",
  "US and Iran hold fire for a second day while mediators pursue ceasefire talks",
  "Iran-backed militias target Saudi oil sites as the US and Iran hold fire for a third day",
  "Iran fires ballistic missiles at US forces as American and Saudi jets strike militia sites in Iraq",
  "Iran targets a key US air base in Jordan as US-Saudi strikes kill at least 20 fighters in Iraq",
  "US hits dozens of IRGC targets as an Iranian strike kills a worker in Kuwait",
  "Iran attacks two tankers in Hormuz as Kuwait intercepts Iranian drones",
  "Iranian drones hit vital facilities in Kuwait as a blast erupts near another tanker",
  "Gulf allies help avert new US strikes as Iran rejects restoring prewar access to Hormuz",
  "Iran denies US talks are under way as Oman negotiations focus on a temporary Hormuz route",
  "The US has used virtually all of its Army long-range precision missiles during the Iran war",
  "Iran and Oman agree on Hormuz route coordinates but Tehran says safe passage is not assured",
  "The US rules out transit fees as Iran says a Hormuz deal with Oman is in final drafting",
  "Iran-backed Houthi attacks on Marib kill two and injure 14",
  "The UAE says Iran fired a missile at an ADNOC vessel transiting the Strait of Hormuz",
  "Yemen's Houthis attack Mocha port and claim a strike on a Saudi Aramco facility",
  "Iran demands war reparations and US concessions before reopening the Strait of Hormuz",
  "Houthi missiles kill four in an attack on a vessel in the Bab el-Mandeb Strait",
  "Pakistan presses to revive US-Iran talks before the interim peace deal expires",
  "Another US aircraft carrier heads toward the Middle East as the Navy maintains its blockade of Iranian ports",
  "The UAE blames Iran after drones hit two ADNOC tankers in the Strait of Hormuz",
  "Israeli strikes in southern Lebanon kill at least 11 in the deadliest attacks since the June truce",
  "The top US commander visits the USS Lincoln as the Iran peace-deal deadline nears with no extension",
  "Iran threatens military action to break the US blockade as diplomacy stalls",
  "The UAE says two Iranian ballistic missiles targeted maritime traffic in the first reported attack in weeks",
  "The UAE suspends all trade with Iran after renewed missile fire",
  "Iran rejects new US economic threats as Pakistan presses efforts to revive talks",
  "Only seven commodity ships cross Hormuz as US-Iran peace talks remain in limbo",
  "Iran threatens alternate Gulf oil routes if neighbors join the US economic campaign",
  "The US blockade redirects 70 ships as Iran lists new Hormuz transit restrictions",
  "Iran threatens a harsh response as the US expands sanctions amid the Hormuz impasse",
  "Iran and Oman outline a temporary Hormuz corridor after a tanker strike",
  "Iran says a potential Hormuz deal with Oman would bar military vessels",
  "Qatar's prime minister goes to Tehran as regional powers seek an Iran-war off-ramp",
  "Six months of war leave Iran's government intact as Gulf allies seek new security ties",
  "An unknown projectile strikes a tanker in Hormuz with no casualties reported",
  "US forces strike Iranian rocket launchers on Larak Island, ending a monthlong lull",
  "UAE air defenses intercept an Iranian drone over the country's territorial waters",
  "US forces strike Iranian air defenses, radar systems and maritime assets",
  "Iran fires missiles and drones at Gulf states after a night of US bombardment",
  "Iran fires missiles and drones at Kuwait in retaliation for renewed US bombardment",
  "Weapons experts say fragments at an Iranian wedding strike site point to US guided munitions after five deaths",
  "US forces strike three Iranian oil tankers after reported missile attacks on Navy warships",
  "Iran plans a new exclusion zone for ships near the Strait of Hormuz",
  "Strait of Hormuz traffic falls to its lowest level since May after US and Iranian strikes on ships",
  "US forces destroy five Iranian oil tankers after IRGC missile attacks on a Navy warship",
  "The US and Iran trade the war's biggest wave of attacks on shipping",
  "Iranian strikes damage an A-10 and roughly eight F-15s at a US-used base in Jordan",
  "Iran-backed Houthis seize Mayun Island in Bab el-Mandeb as Saudi Arabia shuts a drone-hit oil pipeline",
  "Iraq confirms the Saudi pipeline attacks came from Maysan province and dismisses the local commander",
  "An Iranian cargo ship is struck in the Strait of Hormuz, killing one, as regional shipping talks are postponed",
];

function getUtcDate(date) {
  return new Date(`${date}T12:00:00Z`);
}

function toDateKey(date) {
  return date.toISOString().slice(0, 10);
}

const DAILY_HEADLINE_BY_DATE = new Map(
  IRAN_WAR_DAILY_HEADLINES.map((headline, index) => {
    const date = getUtcDate(IRAN_WAR_START);

    date.setUTCDate(date.getUTCDate() + index);

    return [
      toDateKey(date),
      {
        date: toDateKey(date),
        title: typeof headline === "string" ? headline : headline.title,
      },
    ];
  })
);

export function buildIranWarDays(endDate = IRAN_WAR_CHECK.date) {
  const days = [];
  const cursor = getUtcDate(endDate);
  const firstDay = getUtcDate(IRAN_WAR_START);

  while (cursor >= firstDay) {
    const date = toDateKey(cursor);
    const ruling = [...IRAN_WAR_STATUS_CHANGES]
      .reverse()
      .find((change) => change.date <= date);
    const headline = DAILY_HEADLINE_BY_DATE.get(date);

    if (!headline) {
      throw new Error(`Missing daily Iran war headline for ${date}`);
    }

    days.push({ ...ruling, date, headline });
    cursor.setUTCDate(cursor.getUTCDate() - 1);
  }

  return days;
}
